const authenticated_en = require('./authenticated.json')
export default authenticated_en